module.exports = __webpack_public_path__ + "static/media/for-founders-second.e7b65b59.jpg";